import { render, staticRenderFns } from "./MainInput.vue?vue&type=template&id=96374f38&scoped=true&"
import script from "./MainInput.vue?vue&type=script&lang=js&"
export * from "./MainInput.vue?vue&type=script&lang=js&"
import style0 from "./MainInput.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MainInput.vue?vue&type=style&index=1&id=96374f38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96374f38",
  null
  
)

export default component.exports